namespace $.$$ {

	/** Публичный список лендов, за которыми пуш-сервису надо следить. */
	export class $bog_gram_monitor extends $giper_baza_dict.with({
		Watch: $giper_baza_list_str,
	}) {}

}
